import { Card, Checkbox, Flex, Input, Spacer, Stack, Text, VStack } from '@chakra-ui/react';
import { SubmitStepButton } from './SubmitStepButton';

import { Labeled } from '@partiu/ui/components/molecules/Labeled.tsx';
import { useState } from 'react';

import { useForm } from 'react-hook-form';

import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';

import { IStep } from './interfaces';
import { useNotificationCentralContext } from '../notification-central.context';

export function EditPushStep({ HeaderComponent, onSubmit }: IStep) {
  const { name } = useTheme();
  const { register, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      subject: 'Você agora faz parte do Clube ' + name,
      message: 'Você agora faz parte do Clube ' + name,
    },
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const { setFormData } = useNotificationCentralContext();

  const subject = watch('subject');
  const message = watch('message');

  const handleSubmitStep = () => {
    setFormData((oldState) => ({
      ...oldState,
      pushSubject: subject,
      pushBody: message,
    }));
    handleSubmit(() => reset());
    onSubmit();
  };

  return (
    <>
      <HeaderComponent title={'Edite antes de enviar'} />
      <Stack direction={['column', 'row']} alignItems={'flex-start'} spacing={5}>
        <Card width={{ base: '100%', lg: '600px' }} title="Enviar Email" padding={4}>
          <form style={{ height: '100%' }} onSubmit={handleSubmitStep}>
            <VStack height={'100%'} spacing={5}>
              <Labeled label={'Titulo'}>
                <Input {...register('subject', { required: true })} />
              </Labeled>
              <Labeled label={'Mensagem'}>
                <Input {...register('message', { required: true })} />
              </Labeled>
              <Spacer />
              <Checkbox isChecked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)}>
                Estou ciente de que o conteúdo do push notification é de minha responsabilidade
              </Checkbox>
              {/* <Button
                marginTop={'auto'}
                width={'100%'}
                colorScheme={'green'}
                isDisabled={!acceptedTerms}
                type={'submit'}
                isLoading={mutation.isLoading}
              >
                Enviar
              </Button> */}
              <SubmitStepButton
                onSubmit={handleSubmitStep}
                isDisabled={!acceptedTerms || !subject?.trim() || !message?.trim()}
              />
            </VStack>
          </form>
        </Card>
        <Card title={'Visualização'} maxWidth={'400px'} minWidth={'400px'} paddingY="8px">
          <VStack backgroundPosition="top-left" width="100%" spacing={0}>
            <Flex
              flexDir="column"
              padding={0}
              backgroundColor="white"
              borderRadius="5%"
              wordBreak="normal"
              overflowWrap="break-word"
              width="100%"
            >
              <Flex flexDir="column" px={2} justifyContent="center" padding={'16px'}>
                <Text fontWeight="bold">{subject}</Text>
                <Text>{message}</Text>
              </Flex>
            </Flex>
          </VStack>
        </Card>
      </Stack>
    </>
  );
}
